var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCancelFile = function SvgIconCancelFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    fillRule: "evenodd",
    d: "M10 18.833a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667M6.911 13.59a.833.833 0 0 1 0-1.178l1.91-1.911-1.91-1.91A.833.833 0 1 1 8.09 7.41L10 9.322l1.911-1.91a.833.833 0 1 1 1.179 1.178l-1.911 1.91 1.91 1.912a.833.833 0 0 1-1.178 1.178l-1.91-1.91-1.911 1.91a.833.833 0 0 1-1.179 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconCancelFile;